const initialState = {};

const ConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'WELCOME_BANNER_SET': {
            return action.payload;
        }

        default:
            return state;
    }
};

export default ConfigReducer;
